import {gql} from "@apollo/client";

export const GET_ORGANIZATION_REFEREES = gql`
    query OrganizationReferees($q: String, $organizationId: Int, $sports: [String], $status: String, $page: Int, $pageSize: Int) {
        organizationReferees(q: $q, organizationId: $organizationId, sports: $sports, status: $status, page: $page, pageSize: $pageSize) {
            objects {
                id
                fullName
                logoUrl
                rating
                preferences { sports { key name } }
                user { email mobile }
                location { city state country }
                profileOrganizations {
                    id
                    status
                    group { id }
                    organization { id name }
                }
            }
            page
            pages
            hasNext
            hasPrev
        }
    }
`;
